export default __webpack_public_path__ + "static/media/iosIcon.78900100.png";